import { render, staticRenderFns } from "./Titletab.vue?vue&type=template&id=14a042f6&lang=pug"
import script from "./Titletab.vue?vue&type=script&lang=js"
export * from "./Titletab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports